import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DISABLED_GRAPHS,
  getDisabledData,
  getEmployeeCountText,
  listLimit,
} from '../../../../shared/util/companyReport';
import BarChart from '../../components/graphs/barChart/BarChart';
import CircleGraph from '../../components/graphs/circleGraph/CircleGraph';
import TopThree from '../../components/graphs/topThree/TopThree';

function PhysicalHealth({ data, coData, onOpenModal, graphLimit }) {
  const { t } = useTranslation();
  const {
    lthc_yes_no,
    lthc_yes,
    lthc,
    seeking_treatment_yes,
    seeking_treatment_no,
    eye_strain_no,
    eye_strain,
    colds_flu_no,
    colds_flu,
    menopause_no,
    menopause,
    absence,
    bmi_healthy_no,
    bmi_healthy,
    smoked_per_day,
    smoke_yes,
    smoke_no,
  } = data;
  const {
    showLthcList,
    seekingTreetmentCounter,
    menstrualStatusCounter,
    smoking_plus_smoked_per_day_counter,
    lthc_counter,
    working_day_conditions_counter,
    colds_flu_counter,
    absence_counter,
    bmi_calculated,
    smoking_counter,
    lthc_yes_counter,
  } = coData;

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const dataToDisplay = [];

  lthc.forEach((item) => {
    dataToDisplay.push(item.title);
  });
  const lthcListDisabled = ['anaemia', 'fibromyalgia', 'asthma'];

  const treatment = [
    {
      date: t('PHL001'),
      value: seeking_treatment_yes,
    },
    { date: t('PHL002'), value: seeking_treatment_no },
  ];

  const smoking_status = [
    { date: t('AS004'), value: smoke_yes },
    { date: t('AS005'), value: smoke_no },
  ];

  return (
    <>
      <CircleGraph
        title={t('PHL007')}
        preText={getEmployeeCountText(lthc_counter)}
        subTitle=""
        square
        colour="colour1"
        value={lthc_yes_no}
        large
        percent={lthc_yes}
        modalText={t('PHL008')}
        onOpenModal={onOpenModal}
        disabled={lthc_counter < graphLimit}
      />
      <TopThree
        title={t('PHL027')}
        preText={getEmployeeCountText(lthc_yes_counter)}
        square
        value={!showLthcList || dataToDisplay.length < listLimit ? lthcListDisabled : dataToDisplay}
        disabled={!showLthcList || dataToDisplay.length < listLimit}
      />
      <BarChart
        title={t('PHL009')}
        subtitle={t('PHL010')}
        preText={getEmployeeCountText(seekingTreetmentCounter)}
        data={treatment}
        unit="%"
        modalText={t('PHL011')}
        onOpenModal={onOpenModal}
        disabled={seekingTreetmentCounter < graphLimit}
      />
      <CircleGraph
        title={t('PHL012')}
        preText={getEmployeeCountText(working_day_conditions_counter)}
        square
        colour="colour2"
        value={eye_strain_no}
        large
        percent={eye_strain}
        modalText={t('PHL013')}
        onOpenModal={onOpenModal}
        disabled={working_day_conditions_counter < graphLimit}
      />
      <CircleGraph
        title={t('PHL014')}
        subtitle={t('PHL015')}
        preText={getEmployeeCountText(colds_flu_counter)}
        square
        colour="colour3"
        value={colds_flu_no}
        large
        percent={colds_flu}
        modalText={t('PHL016')}
        onOpenModal={onOpenModal}
        disabled={colds_flu_counter < graphLimit}
      />
      <CircleGraph
        title={t('PHL017')}
        square
        colour="colour1"
        preText={getEmployeeCountText(menstrualStatusCounter)}
        value={menopause_no}
        large
        percent={menopause}
        modalText={t('PHL018')}
        onOpenModal={onOpenModal}
        disabled={menstrualStatusCounter < graphLimit}
      />
      <CircleGraph
        title={t('PHL019')}
        subTitle={t('PHL020')}
        preText={getEmployeeCountText(absence_counter)}
        square
        colour="colour2"
        value={absence}
        subText={t('PHL021')}
        large
        modalText={t('PHL022')}
        onOpenModal={onOpenModal}
        disabled={absence_counter < graphLimit}
      />

      <CircleGraph
        title={t('PHL025')}
        square
        preText={getEmployeeCountText(bmi_calculated)}
        colour="colour3"
        value={bmi_healthy_no}
        large
        percent={bmi_healthy}
        modalText={t('PHL026')}
        onOpenModal={onOpenModal}
        disabled={bmi_calculated < graphLimit}
      />
      <BarChart
        title={t('AS021')}
        preText={getEmployeeCountText(smoking_counter)}
        data={smoking_status}
        unit="%"
        startZero
        modalText={t('AS022')}
        onOpenModal={onOpenModal}
        disabled={smoking_counter < graphLimit}
      />
      <CircleGraph
        preText={getEmployeeCountText(smoking_plus_smoked_per_day_counter)}
        title={t('AS023')}
        square
        colour="colour1"
        value={smoked_per_day}
        subText={t('AS024')}
        large
        modalText={t('AS025')}
        onOpenModal={onOpenModal}
        disabled={smoking_plus_smoked_per_day_counter < graphLimit}
      />
    </>
  );
}
export default PhysicalHealth;
